'use strict';

import defaultTemplate from '../../core/default.html';
import devicesListTemplate from './devices.list.html';
import devicesNewTemplate from './devices.new.html';
import lintalertPropertiesTemplate from './config/lintalert/properties.html';

import Devices from './devices.ctrl';

function DevicesRouter($urlRouterProvider, $stateProvider) {
  $stateProvider
    .state('main.devices', {
      url: '/devices',
      template: defaultTemplate
    })
    .state('main.devices.list', {
      url: '/list',
      template: devicesListTemplate,
      controller: 'DevicesListController as vm',
      resolve: {
        permission: ($q, utils, PermissionsService) => {
          return PermissionsService.canIViewDeviceList()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.devices.list');
        }
      }
    })
    .state('main.devices.new', {
      url: '/new?:locationId&:tab&:deviceModelId',
      template: devicesNewTemplate,
      controller: 'DevicesNewController as vm',
      resolve: {
        permission: ($q, utils, PermissionsService) => {
          return PermissionsService.canICreateDevice()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.devices.new');
        }
      }
    })

    .state('main.devices.info.130', {
      views: {
        'properties': {
          url: '/130',
          template: lintalertPropertiesTemplate,
          controller: 'LintAlertController as vm',
          resolve: {
            permission: ($q, utils, PermissionsService) => {
              const SELECTED_DEVICE_LOCAL_STORAGE_KEY = 'Selected-Device';
              let device = utils.getStorageItem(SELECTED_DEVICE_LOCAL_STORAGE_KEY);
              return PermissionsService.canIEditDevice(device)
                ? $q.resolve()
                : $q.reject('Route permission check failed: main.devices.info.130/properties');
            }
          }
        }
      }
    });

}

export default angular
  .module('devices.router', [
    Devices
  ])
  .config(DevicesRouter)
  .name;
